import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"392px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-wrapper card-rounded min-h-225px overflow-hidden h-275px border border-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200" }, [
    /*#__PURE__*/_createElementVNode("h1", {
      class: "text-black-50 opacity-20 fs-1",
      style: {"transform":"rotate(45deg)"}
    }, " User has not uploaded this file yet ")
  ])
], -1)
const _hoisted_3 = {
  href: "#",
  class: "fs-4 text-dark fw-bold text-hover-primary lh-base"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentEmptyCard',
  props: {
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.title), 1)
  ]))
}
}

})